import { State } from '@/models/main';
import { GetterTree } from 'vuex';

export const getters: GetterTree<State, State> = {
  prevUrl: (state: State) => state.routerData.prevUrl,
};
